import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { authSettings } from '@/services/auth/config'
import store from '@/store'

export default vuexOidcCreateStoreModule(
    authSettings,
    {
        namespaced: true,
        dispatchEventsOnWindow: false,
        routeBase: '/',
    },
    {
        accessTokenExpiring: () => {
            store
                .dispatch('auth/authenticateOidcSilent')
                .catch(() => store.dispatch('auth/removeOidcUser'))
        },
        // userLoaded: (user) => console.log('OIDC user is loaded:', user),
        // userUnloaded: () => console.log('OIDC user is unloaded'),
        // accessTokenExpired: () => console.log('Access token did expire'),
        // silentRenewError: () => console.log('OIDC user is unloaded'),
        // userSignedOut: () => console.log('OIDC user is signed out'),
        // oidcError: (payload) => console.log('OIDC error', payload),
        // automaticSilentRenewError: (payload) =>
        //     console.log('OIDC automaticSilentRenewError', payload),
    }
)
